import { render, staticRenderFns } from "./UserPublicProfileModal.vue?vue&type=template&id=0fa03a2c&"
import script from "./UserPublicProfileModal.vue?vue&type=script&lang=js&"
export * from "./UserPublicProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports